import { InjectionToken } from '@angular/core';

export const REQUEST_SOURCE = new InjectionToken<string>('Request Source');
export const REQUEST_ACTION = new InjectionToken<string>('Request Action');
